const ApplyNowButton = () => {
  return (
    <a
      href="#application-form"
      className="bg-custom-red py-3 px-6 text-2xl font-bold text-white whitespace-nowrap w-min hover:bg-black hover:text-white transition-all duration-100"
    >
      Hemen Başvur
    </a>
  );
};

export default ApplyNowButton;
